import styled from 'styled-components';

import CampaignMenu from './CampaignMenu';

const SubCampaignMenu = styled(CampaignMenu).withConfig({
  displayName: 'SubCampaignMenu',
})``;

export default SubCampaignMenu;
